/** Values of @StandardFilterType accepted by spMR50_ChaseOverreadFeedbackList_sel. */
export enum StandardFilterType {
  CODER_VIEW_ALL = "CoderViewAll",
  CODER_VIEW_COMPLETE = "CoderViewComplete",
  CODER_VIEW_INCOMPLETE = "CoderViewIncomplete",
  MANAGER_VIEW_ALL = "ManagerViewAll",
  MANAGER_VIEW_COMPLETE = "ManagerViewComplete",
  MANAGER_VIEW_INCOMPLETE = "ManagerViewIncomplete",
}
